import { TRANSFORMERS_URL } from "api/constants";
import { escapeRegExp } from "utils/common/escape-regex";

/**
 * Extract the uuid used for the book in the transformers service.
 * It can be extracted from the result of `getMediaKey(downloadUrl)`,
 * which is an URL of (hopefully) this shape: "<TRANSFORMERS_URL>/books/<UUID>/".
 */
export const extractTransformersUidFromMediaKey = (mediaKey) => {
    const regex = new RegExp(`${escapeRegExp(TRANSFORMERS_URL)}/books/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})`);
    const matches = (mediaKey || '').match(regex);
    return matches ? matches[1] : null;
}
